import axiosInstance from '../mainService';

const applicantService = {
    addApplicant(applicant) {
        return axiosInstance.post('/upload-data-career', applicant);
    },
    deleteApplicant(applicantId, applicantCv) {
        return axiosInstance.delete(`/delete-career/${applicantId}/${applicantCv}`);
    },
    updateApplicant(applicant) {
        return axiosInstance.put(`/update-data/t107_applicants/${applicant.id}`, applicant);
    },
    getApplicants(period, search, page, limit, company) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/data-career/${period}/name/${sanitizedSearch}/${page}/${limit}/${company}`)
            .then(response => {
                return {
                    data: response.data,
                    headers: response.headers, // Total data dari header
                };
            });
    },
    totalAllApplicants(search, company_id) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/count-data/t107_applicants/name/${sanitizedSearch}/${company_id}`);
    },
    downloadApplicantList(period, company){
        return axiosInstance.get('/download-data-career/' + period + '/' + company);
    }
};

export default applicantService;